






























































import { Component, Prop, Mixins } from 'vue-property-decorator'
import Copy from '@globalUtils/copy'
import MixinCopy from '@globalMixins/copy'

@Component
export default class Guide extends Mixins(MixinCopy) {
  @Prop({ type: Object, required: true }) readonly product!: {}
  @Prop({ type: String, default: 'guide-content' }) readonly contentId!: string
  @Prop({ type: Boolean, default: false }) readonly custom!: boolean
  @Prop({ type: Boolean, default: false }) readonly isList!: boolean
  @Prop({ type: Boolean, default: true }) readonly openCopyBtn!: boolean
  @Prop({ type: Boolean, default: false }) readonly openDblclickCopy!: boolean
  @Prop({
    type: String,
    default() {
      return this.product['mainImg']
    }
  })
  readonly productImg!: string

  imgError: string[] = []
  copyContent = '复制导购文案'
  clearTimeout: any = null
  clickProductImg() {
    return this.$emit('click-product-img', this.product)
  }

  copyGuide(selector: string | HTMLElement) {
    if (this.copyContent === '复制成功') return
    new Copy(selector, {
      config: {
        target(trigger: HTMLElement) {
          return trigger.nextElementSibling
        }
      },
      callback: () => {
        this.copyContent = '复制成功'
        this.clearTimeout = setTimeout(() => {
          this.copyContent = '复制导购文案'
        }, 2000)
      }
    })
  }

  mouseout() {
    this.copyContent = '复制导购文案'
    clearTimeout(this.clearTimeout)
  }
  errHandle(imgDiv: any, img: string) {
    if (this.imgError.includes(img)) return
    imgDiv.target.setAttribute('src', img)
    this.imgError.push(img)
    imgDiv.onerror = null // 避免请求失败后不断请求
  }
}
